module.exports = {
    IDLE : 'IDLE',
    FETCHING : 'FETCHING',
    FETCHED : 'FETCHED',
    FETCH_FAILED : 'FETCH_FAILED',
    SAVING : 'SAVING',
    SAVED : 'SAVED',
    SAVE_FAILED: 'SAVE_FAILED',
}
